import React from 'react'
import store from './redux/store'
import { Provider } from 'react-redux'
import DataRetriever from './DataRetriever'
// eslint-disable-next-line no-unused-vars
import { CommonProps } from '../models/types'

const ChatbotProvider = (props: CommonProps) => {
  return (
    <Provider store={store}>
      <DataRetriever {...props} />
    </Provider>
  )
}

export default ChatbotProvider
